import React, { ReactElement, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import ImageButton from './Buttons/ImageButton';

const translateActivities = (key, options?) => translate('activities', key, { ...options });

type Props = {
  onUpload: (file) => void;
};

const FileUpload = ({ onUpload }: Props): ReactElement => {
  const uploadRef: any = useRef(null);
  const { wrapperClass, textClass } = useStyles();

  const handleUpload = () => {
    uploadRef.current.click();
  };

  const onClick = (e) => {
    e.target.value = null;
  };

  const IMG_EXTENSIONS = ['.jpg', '.jpeg', '.pdf', '.png'];
  const MAX_FILE_SIZE = 5242880;

  const hasExtension = (fileName) => {
    const pattern = '(' + IMG_EXTENSIONS.join('|').replace(/\./g, '\\.') + ')$';
    return new RegExp(pattern, 'i').test(fileName);
  };

  const onDropFile = (e) => {
    const file = e.target.files[0];
    if (hasExtension(file.name) && file.size < MAX_FILE_SIZE) {
      onUpload(file);
    } else {
      console.error('Invalid file upload');
    }
  };
  return (
    <>
      <Box className={wrapperClass}>
        <ImageButton onClick={handleUpload} style={{}} imageName={'uploadButton'} />
        <Typography variant="body2" className={textClass}>
          {translateActivities('uploadFile')}
        </Typography>
      </Box>
      <input
        type="file"
        ref={uploadRef}
        name={'upload'}
        multiple={false}
        onChange={onDropFile}
        onClick={onClick}
        accept={IMG_EXTENSIONS.join(', ')}
        style={{ display: 'none' }}
      />
    </>
  );
};
export default FileUpload;

const useStyles = makeStyles((theme) => ({
  wrapperClass: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    marginBottom: remCalc(8),
    marginLeft: remCalc(20),
    [theme.breakpoints.down('md')]: {
      marginLeft: remCalc(10),
    },
    [theme.breakpoints.down('xs')]: {
      marginLeft: remCalc(5),
    },
  },
  textClass: {
    paddingTop: remCalc(16),
    [theme.breakpoints.down('md')]: {
      fontSize: '4vmin',
      textAlign: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: remCalc(8),
    },
  },
}));
